<template>
  <div>
    <el-dialog
      class="dialog"
      title="产品信息"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="850px"
    >
      <div class="wrapper">
        <el-row
          class="title"
          :gutter="10"
        >
          <el-col :span="4">品牌</el-col>
          <el-col :span="4">子品牌</el-col>
          <el-col :span="3">容量</el-col>
          <el-col :span="3">是否多联包</el-col>
          <el-col :span="3">规格</el-col>
          <el-col :span="3">最小陈列件</el-col>
          <el-col :span="2">排面数</el-col>
          <el-col :span="2"></el-col>
        </el-row>
        <el-row
          :gutter="10"
          class="content"
          v-for="(item, index) in productList" :key="index"
        >
          <el-col :span="4">
            <el-select
              v-model="item.brandInfo"
              placeholder="选择品牌"
              filterable
              size="mini"
              @change="handleBrandChange(index)"
            >
              <el-option
                v-for="brand in brandList"
                :key="brand.abiBrandId"
                :label="brand.abiBrandDesc"
                :value="`${brand.abiBrandCode},${brand.abiBrandDesc}`"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="item.subBrandInfo"
              placeholder="选择子品牌"
              filterable
              size="mini"
              @change="handleSubBrandChange"
            >
              <el-option
                v-for="subBrand in getSubBrandList(item.brandInfo)"
                :key="subBrand.abiBrandId"
                :label="subBrand.abiBrandDesc"
                :value="`${subBrand.abiBrandCode},${subBrand.abiBrandDesc}`"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 容量 -->
          <el-col :span="3">
            <el-select
              v-model="item.volume"
              placeholder="选择容量"
              size="mini"
            >
              <el-option
                v-for="spec in specList"
                :key="spec.key"
                :label="spec.value"
                :value="spec.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 是否多联包 -->
          <el-col :span="3">
            <el-select
              v-model="item.multiPackFlag"
              placeholder="是否多联包"
              size="mini"
              @change="flagChange($event, item)"
            >
              <el-option
                v-for="list in multiPackList"
                :key="list.key"
                :label="list.value"
                :value="list.key"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 规格 -->
          <el-col :span="3">
            <el-select
              v-model="item.multiPackSpec"
              placeholder="选择规格"
              size="mini"
              :disabled="!(Number(item.multiPackFlag))"
              @change="getRowQty($event, item)"
            >
              <el-option
                v-for="size in sizeList"
                :key="size.key"
                :label="size.value"
                :value="size.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 最小陈列件 -->
          <el-col :span="3">
            <el-select
              v-model="item.minDisplayQty"
              placeholder="最小陈列件"
              size="mini"
              @change="getRowQty($event, item)"
            >
              <el-option
                v-for="qty in 30"
                :key="qty"
                :label="qty"
                :value="qty"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- 排面数 -->
          <el-col :span="2" style="text-align: center">
            {{ item.rowQty || '' }}
          </el-col>
          <el-col :span="2">
            <div style="height: 50px">
              <el-button
                type="primary"
                size="mini"
                @click="handleAddRow()"
              >新增</el-button>
            </div>
            <div v-if="!(productList.length === 1 && !index)">
              <el-button
                type="warning"
                size="mini"
                @click="handleDeleteRow(index)"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="danger" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { commonUtils } from '../../../utils/common'
// import _ from 'lodash'
export default {
  name: 'product-config-dialog',
  props: {
    row: {
      type: String,
      default: ''
    },
    column: {
      type: String,
      default: ''
    },
    brandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    specList: {
      type: Array,
      default: () => {
        return []
      }
    },
    sizeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
    // defaultProductList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // }
  },
  watch: {
    // tradePerfectScopeDetailList () {
    //   if (this.defaultProductList.length) {
    //     this.productList = _.cloneDeep(this.defaultProductList)
    //   }
    // }
  },
  data () {
    return {
      productList: [{
        brandInfo: '',
        brandName: '',
        brandCode: '',
        subBrandInfo: '',
        subBrandName: '',
        subBrandCode: '',
        volume: '',
        multiPackSpec: '',
        minDisplayQty: '',
        multiPackFlag: '',
        rowQty: null
      }],
      multiPackList: [
        {
          key: '1',
          value: '是'
        },
        {
          key: '0',
          value: '否'
        }
      ],
      tempSizeList: []
    }
  },
  methods: {
    // 新增行
    handleAddRow () {
      this.productList.push({
        brandInfo: '',
        brandName: '',
        brandCode: '',
        subBrandInfo: '',
        subBrandName: '',
        subBrandCode: '',
        volume: '',
        multiPackSpec: '',
        minDisplayQty: '',
        multiPackFlag: '',
        rowQty: null
      })
    },
    // 删除行
    handleDeleteRow (index) {
      this.productList.splice(index, 1)
    },
    // 取消
    handleCancel () {
      this.$emit('closeProductDialog')
    },
    // 确定
    handleConfirm () {
      let formatedData = this.formatData()
      if (this.checkData()) {
        this.$emit('addProductInfo', formatedData)
      }
    },

    // 检查数据
    checkData () {
      return this.checkDataComplete() && this.checkDataDuplicate()
    },
    // 校验数据是否重复
    checkDataDuplicate () {
      // let checkResult = true
      let hasSomeProduct = false
      for (let i = 0; i < (this.productList.length - 1); i++) {
        let obj = commonUtils.deepClone(this.productList[i])
        delete obj.minDisplayQty
        let objNext = commonUtils.deepClone(this.productList[i + 1])
        delete objNext.minDisplayQty
        if (JSON.stringify(obj) === JSON.stringify(objNext)) {
          hasSomeProduct = true
          break
        }
      }
      if (hasSomeProduct) {
        this.$message.warning('配置重复')
      }
      let checkResult = !hasSomeProduct
      return checkResult
    },
    // 校验数据是否完整
    checkDataComplete () {
      let checkResult = true
      this.productList.forEach(item => {
        for (let key in item) {
          if (!item[key]) checkResult = false
        }
      })
      if (!checkResult) {
        this.$message.warning('请正确选择所有数据')
      }
      return checkResult
    },
    // 格式化数据
    formatData () {
      return this.productList.map(item => {
        item.brandCode = item.brandInfo.split(',')[0]
        item.brandName = item.brandInfo.split(',')[1]
        item.subBrandCode = item.subBrandInfo.split(',')[0]
        item.subBrandName = item.subBrandInfo.split(',')[1]
        return item
      })
    },

    // 根据所选父品牌筛选子品牌
    getSubBrandList (parentBrand) {
      if (!parentBrand) return []
      let brandCode = parentBrand.split(',')[0]
      let subBrandList = []
      this.brandList.forEach(item => {
        if (item.abiBrandCode === brandCode) {
          subBrandList = item.subBrandList
        }
      })
      return subBrandList
    },
    // 父品牌改变 清空子品牌
    handleBrandChange (index) {
      this.productList[index].subBrandInfo = ''
    },
    handleSubBrandChange () {
      this.$forceUpdate()
    },
    resetData () {
      this.productList = this.$options.data().productList
    },
    // 根据是否多联包展示对应规格
    flagChange (e, item) {
      if (e === '1') {
        // this.tempSizeList = this.sizeList
        item.multiPackSpec = ''
      } else {
        // this.tempSizeList = [{
        //   key: '1*1',
        //   value: '1*1'
        // }]
        item.multiPackSpec = '1*1'
      }
      this.getRowQty(e, item)
    },
    // 计算排面数
    getRowQty (e, item) {
      item.rowQty = null
      if (item.multiPackSpec && item.minDisplayQty) {
        let specList = item.multiPackSpec.split('*')
        specList.sort((a, b) => {
          return Number(b) - Number(a)
        })
        item.rowQty = Number(specList[0]) * item.minDisplayQty
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  .el-col {
    font-weight: 600;
    text-align: center;
  }
}
</style>
